import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=3bb58bc4"
import script from "./mail.vue?vue&type=script&lang=js"
export * from "./mail.vue?vue&type=script&lang=js"
import style0 from "./mail.vue?vue&type=style&index=0&id=3bb58bc4&prod&lang=css"
import style1 from "./mail.vue?vue&type=style&index=1&id=3bb58bc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports